import React, { useState, useEffect } from "react";
import "./invoice.css";
const InvoiceBody = ({
  saleData,
  detailsOverride,
  startIndex = 0,
  hideCountry = false,
  showCountryPrintToggle = false,
  hideCountryInPrint = false,
  onHideCountryInPrintChange,
}) => {
  // Invoice body

  /// end

  // console.log(sale)
  let [sale, saleSet] = useState([]);
  let [saleDetails, saleDetailsSet] = useState([]);

  useEffect(() => {
    saleSet(saleData || {});

    if (detailsOverride !== undefined) {
      saleDetailsSet(detailsOverride);
    } else if (saleData && saleData.details != undefined) {
      saleDetailsSet(saleData.details);
    }
  }, [saleData, detailsOverride]);

  return (
    <>
      <table className={"invoice-table"}>
        <thead>
          <td style={{ textAlign: "left" }}>SL</td>
          <td style={{ textAlign: "left" }}>Category</td>

          <td style={{ textAlign: "left" }}>Description</td>
          <td>Brand</td>
          {!hideCountry ? (
            <td>
              <span>Country</span>
              {showCountryPrintToggle ? (
                <label
                  className="invoice-print-toggle no-print"
                  title="Tick to hide Country column while printing"
                >
                  <input
                    type="checkbox"
                    checked={hideCountryInPrint}
                    onChange={(event) =>
                      onHideCountryInPrintChange &&
                      onHideCountryInPrintChange(event.target.checked)
                    }
                  />
                  <span>Hide</span>
                </label>
              ) : null}
            </td>
          ) : null}
          <td>Qty</td>
        </thead>
        <tbody>
          {saleDetails.map((detail, ind) => (
            <tr key={ind}>
              <td style={{ textAlign: "left" }}>{startIndex + ind + 1}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_cat_name}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_name}</td>
              <td>{detail.prod_brand_name}</td>
              {!hideCountry ? <td>{detail.prod_color_name}</td> : null}
              <td>
                {detail.sale_qty} {detail.prod_unit_name}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default InvoiceBody;
